import React from 'react';
import { Link } from 'react-router-dom';

class NotFoundPage extends React.Component{
    render(){
        return <div className='content-wrapper'>
            <p style={{textAlign:"center",fontSize:"80px"}}>

              <Link to="/"> Go to Home </Link>
            </p>
    </div>;
    }
}
export default NotFoundPage;